export const LangText: any = {
    us: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    ca: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    jp: {
        product_name: 'EcoFlow DELTA 3 Max Series',
        tab_product: '概要',
        tab_bundles: 'Bundles',
        tab_support: 'サポート',
        tab_specs: '仕様',
        tab_media: 'Media',
        btn_buy: '今すぐ購入',
    },
    eu: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2,048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_compare: 'Compare',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Buy Now',
    },
    nl: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2,048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundels',
        tab_support: 'Ondersteuning',
        tab_specs: 'Specificaties',
        tab_media: 'Media',
        btn_buy: 'Nu kopen',
    },
    uk: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2,048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_compare: 'Compare',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Buy Now',
    },
    de: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2 048 Wh)',
        tab_product: 'Produkt',
        tab_compare: 'Vergleich',
        tab_support: 'Support',
        tab_specs: 'Technische Daten',
        btn_buy: 'Jetzt shoppen',
        btn_subscribe: 'Abonnieren',
    },
    fr: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2 048 Wh)',
        tab_product: 'Produit',
        tab_compare: 'Comparer',
        tab_support: 'Assistance',
        tab_specs: 'Spécifications',
        btn_buy: 'Acheter',
        btn_subscribe: 'S’abonner',
    },
    es: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2048Wh)',
        tab_product: 'Producto',
        tab_compare: 'Comparativa',
        tab_support: 'Asistencia',
        tab_specs: 'Especificaciones',
        btn_buy: 'Comprar ahora',
        btn_subscribe: 'Suscribirse',
    },
    it: {
        product_name: 'EcoFlow DELTA 3 Max Plus (2.048Wh)',
        tab_product: 'Prodotto',
        tab_compare: 'Confronta',
        tab_support: 'Assistenza',
        tab_specs: 'Specifiche',
        btn_buy: 'Acquista ora',
        btn_subscribe: 'Iscriviti',
    },
};
